import type { SurveyPaginationRefs } from '../types';
import {
  createInitialLogicMatchCounts,
  type LogicEventHistoryEntry,
} from '../../surveyLogic/telemetry/logicAnalyticsTypes';

export function createInitialLogicTrackingRefs(): Pick<
  SurveyPaginationRefs,
  | 'logicEventHistory'
  | 'logicMatchCounts'
  | 'lastVisibleQuestionIds'
  | 'lastVisibleAnswerEntityKeys'
  | 'lastResolvedVariantByQuestionId'
  | 'lastResolvedEndPageId'
  | 'endPageChangeCount'
> {
  return {
    logicEventHistory: [] as LogicEventHistoryEntry[],
    logicMatchCounts: createInitialLogicMatchCounts(),
    lastVisibleQuestionIds: new Set<string>(),
    lastVisibleAnswerEntityKeys: new Set<string>(),
    lastResolvedVariantByQuestionId: new Map<string, string>(),
    lastResolvedEndPageId: undefined,
    endPageChangeCount: 0,
  };
}
